import axios from 'axios'
import { URLS } from './urls';

const API = axios.create({
    baseURL: URLS.BASE_URL,
    timeout: 600000, // Augmenter le timeout à 60 secondes
    "Client-Id": URLS.CLIENT_ID
});

export { API };